// src/api/pointApi.ts
import axios from 'axios';
import { basename } from '../../globals_VITE';

/**
 * Створення, редагування, видалення поінта
 *
 * customer_id
 * point_id
 * name
 * country (берем из customer)
 * city (берем из customer)
 * time_period (по замовчуванню ‘day (face_time_slot/day)’) - клиенту не показываем
 * face_detection (1)  (method/face_detection is true)
 * embedding (1)  (method/embedding is true)
 * demography (3)  (method/demography is true)
 * expiration_time (3) (ораничить 24)
 */

// интерфейс для точки учета
export interface Point {
  customer_id: number;
  point_id: number; // Primary key
  name: string;
  country: string; // берем из customer
  city: string; // берем из customer
  tag?: string; // (optional) тег для точки учета
  start_time: string; // время начала действия точки учета
  end_time: string; // время окончания действия точки учета
}

async function getPoints(): Promise<Point[]> {
  const res = await axios.get<Point[]>('pcnt/point/');
  return res.data;
}

const createPoint = async (data: Partial<Omit<Point, 'point_id'>>): Promise<Point> => {
  console.log('[pointApi] createPoint called with data:', data);
  const res = await axios.post<Point>('pcnt/point/', data);
  //   {
  //     ...data,
  //     time_period: 'day',
  //     face_detection: 1,
  //     embedding: 1,
  //     demography: 1,
  //   }
  // );
  return res.data;
}

const updatePoint = async (point_id: number, data: Partial<Omit<Point, 'point_id'>>): Promise<Point> => {
  console.log('[pointApi] updatePoint called for point_id:', point_id, 'with data:', data);
  const res = await axios.patch<Point>(`pcnt/point/${point_id}/`, data);
  return res.data;
};

const deletePoint = async (point_id: number): Promise<void> => {
  console.log('[pointApi] deletePoint called for point_id:', point_id);
  await axios.delete(`pcnt/point/${point_id}/`);
}

export const pointApi = {
  getPoints,
  createPoint,
  updatePoint,
  deletePoint,
};